'use client'

import { createClient } from '@/utils/saas/supabase/client'
import { type Provider } from '@supabase/supabase-js'
import { getURL } from '@/utils/saas/helpers'
import { redirectToPath } from './server'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

export async function handleRequest(
  e: React.SubmitEvent<HTMLFormElement>,
  requestFunc: (formData: FormData) => Promise<string>,
  router: AppRouterInstance | null = null,
): Promise<boolean | void> {
  // Prevent default form submission refresh
  e.preventDefault()

  const formData = new FormData(e.currentTarget)
  const redirectUrl: string = await requestFunc(formData)

  if (router) {
    // If client-side router is provided, use it to redirect
    return router.push(redirectUrl)
  } else {
    // Otherwise, redirect server-side
    return await redirectToPath(redirectUrl)
  }
}

export async function signInWithOAuth(e: React.SubmitEvent<HTMLFormElement>) {
  // Prevent default form submission refresh
  e.preventDefault()
  const formData = new FormData(e.currentTarget)
  const rawProvider = formData.get('provider')
  if (typeof rawProvider !== 'string') {
    throw new Error('Invalid OAuth provider')
  }
  const provider = rawProvider.trim() as Provider

  // Create client-side supabase client and call signInWithOAuth
  const supabase = createClient()
  // @@TODO
  const redirectURL = getURL('/saas/auth/callback')
  await supabase.auth.signInWithOAuth({
    provider: provider,
    options: {
      redirectTo: redirectURL,
    },
  })
}
